module.exports = __webpack_public_path__ + "static/img/bargain.59fcfa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bargain.png
// module id = gc2n
// module chunks = 64